import { supabase } from '../lib/supabase';

// Test basic network connectivity to Supabase
export const testSupabaseConnectivity = async () => {
  const results = {
    timestamp: new Date().toISOString(),
    tests: {}
  };

  // Test 1: Basic URL reachability
  try {
    const response = await fetch(process.env.REACT_APP_SUPABASE_URL);
    results.tests.basicUrlTest = {
      success: true,
      status: response.status,
      statusText: response.statusText
    };
  } catch (error) {
    results.tests.basicUrlTest = {
      success: false,
      error: error.message,
      type: error.name
    };
  }

  // Test 2: Supabase auth health check
  try {
    const { data, error } = await supabase.auth.getSession();
    results.tests.authHealthCheck = {
      success: !error,
      hasSession: !!data?.session,
      error: error?.message
    };
  } catch (error) {
    results.tests.authHealthCheck = {
      success: false,
      error: error.message,
      type: error.name
    };
  }

  // Test 3: Test a simple database query
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('count')
      .limit(1);
    
    results.tests.databaseConnectivity = {
      success: !error,
      error: error?.message,
      dataReceived: !!data
    };
  } catch (error) {
    results.tests.databaseConnectivity = {
      success: false,
      error: error.message,
      type: error.name
    };
  }

  // Test 4: Try password reset with a fake email to test auth endpoint
  try {
    const { data, error } = await supabase.auth.resetPasswordForEmail('test@nonexistent.com', {
      redirectTo: `${window.location.origin}/reset-password`
    });
    
    results.tests.passwordResetEndpoint = {
      success: true, // Even with fake email, the endpoint should respond
      error: error?.message,
      data: !!data
    };
  } catch (error) {
    results.tests.passwordResetEndpoint = {
      success: false,
      error: error.message,
      type: error.name,
      status: error.status
    };
  }

  return results;
};

// Test different redirect URLs
export const testPasswordResetWithDifferentUrls = async (email) => {
  const redirectUrls = [
    `${window.location.origin}/reset-password`,
    `http://localhost:3000/reset-password`,
    `${window.location.origin}/auth/reset-password`,
    'http://localhost:3000/auth/reset-password'
  ];

  const results = [];

  for (const redirectUrl of redirectUrls) {
    try {
      console.log(`Testing password reset with redirect URL: ${redirectUrl}`);
      
      const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: redirectUrl
      });

      results.push({
        redirectUrl,
        success: !error,
        error: error?.message,
        data: !!data
      });

      // Add a small delay between requests
      await new Promise(resolve => setTimeout(resolve, 1000));
      
    } catch (error) {
      results.push({
        redirectUrl,
        success: false,
        error: error.message,
        type: error.name,
        status: error.status
      });
    }
  }

  return results;
};

// Check environment variables
export const checkEnvironmentConfig = () => {
  return {
    supabaseUrl: process.env.REACT_APP_SUPABASE_URL || 'NOT_SET',
    supabaseKey: process.env.REACT_APP_SUPABASE_ANON_KEY ? 'SET' : 'NOT_SET',
    siteUrl: process.env.REACT_APP_SITE_URL || 'NOT_SET',
    currentOrigin: window.location.origin,
    currentProtocol: window.location.protocol,
    currentHost: window.location.host
  };
};
